<template>
	<div class='login-component'>
		<div class='login-component__wrapper'>
			
			<div class='login-component__title'>
				<span>Акты ЛПО</span>
			</div>

			<div class='login-component__login-form-container'>
				<div class='login-component__login-form-title'>
					<span>Авторизация</span>
				</div>
				<LoginForm @submit='login' class='login-component__login-form'/>
			</div>

			<!-- <div @click='loginTest' class='login-component__test-login-ref'>
				<span>Войти в тестовую учетную запись</span>
			</div> -->

		</div>
	</div>
</template>

<script>
	import LoginForm from './LoginForm';

	import { mapGetters, mapActions } from 'vuex';

	export default {
		name: 'LoginComponent',
		components: {
			LoginForm
		},
		data: () => ({
			username: null,
			password: null,
			remember: true,
		}),

		computed: {
			...mapGetters('auth', {
				s_isLogged: 'isLogged'
			})
		},

		methods: {
			login(creds) {

				const redirect = '/';

				this.s_login(creds).then(res => {
					if (this.s_isLogged) {
						this.$router.push(redirect);					
					} 
				});
			},

			loginTest() {
				const redirect = '/';

				const creds = {
					username: 'test_lpo',
					password: 'test_lpo',
					remember: false
				};

				this.s_login(creds).then(res => {
					if (this.s_isLogged) {
						this.$router.push(redirect);					
					} 
				});
			},

			...mapActions('auth', {
				s_login: 'login'
			})
		}
	};
</script>

<style scoped>
	
	.login-component {
		height: 100vh;
		
		background-image: url('../../assets/files/forest.jpg');
		/*background-position: center;*/
		background-repeat: no-repeat;
		background-size: cover;
	}

	.login-component__wrapper {
		position: relative;

		display: flex;
		flex-direction: column;
		justify-content: center;
		max-width: 450px;

		background-color: rgb(0, 0, 0, 0.75);
		height: 100%;
		margin: auto;
	}

	.login-component__login-form-container {
		transform: translateY(-2rem);
	}

	.login-component__login-form {
		width: 300px;
		margin: auto;
	}

	.login-component__title,
	.login-component__login-form-title {
		color: #ddd;
		text-align: center;
	}

	.login-component__title {
		font-size: 2.8rem;
		font-weight: 200;
		position: absolute;
		width: 100%;
		top: 10%;
	}

	.login-component__login-form-title {
		font-size: 1.3rem;
		font-weight: bold;
		margin-bottom: 2rem;
	} 

	.login-component__test-login-ref {
		font-size: 1rem;
		position: absolute;
		width: 100%;
		bottom: 2rem;
		color: #ddd;
		text-align: center;

		cursor: pointer;

		text-decoration: underline;
	}

	.login-component__test-login-ref:hover {
		color: #fff;
	}

</style>